import { useSyncExternalStore } from "react";
import { queue } from "./queue";

/** Toestand van de offline-wachtrij (aantal wachtend, versturen, offline). */
export const useQueueState = () => useSyncExternalStore(queue.subscribe, queue.getState);
